import { NgModule } from '@angular/core';
import { VerifyService } from '../services/verify.service';

@NgModule({
  providers: [VerifyService],
})
export class VerifyModule {}
